import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup, UntypedFormArray, UntypedFormControl } from "@angular/forms";
import { GSFReport } from "../GSF-report.service";
import { ActivityModelNew, QuestionModel, QuestionError } from "../models";
import { TranslateService } from "@ngx-translate/core";
import { DuplicateCheckService } from "../service/duplicate-check.service";
import { InputValidationService } from "../service/input-validation.service";
import { Constants } from "../constants/question-constant";

@Component({
  selector: "app-question",
  templateUrl: "./question.component.html",
  styleUrls: ["./question.component.scss"],
})
export class QuestionComponent implements OnInit {
  @Input()
  questionForm: UntypedFormGroup;
  @Input()
  question: QuestionModel;
  @Input()
  index: number;
  @Input()
  activity: ActivityModelNew;
  @Input() pillarName: string;
  selectedlang: string;

  @Output() questionFormValid: EventEmitter<string> = new EventEmitter();

  constructor(
    private readonly dupCheckService: DuplicateCheckService,
    private readonly translate: TranslateService,
    private readonly inputValService: InputValidationService,
    public report: GSFReport
  ) {
    translate.setDefaultLang("eng");
    this.selectedlang = "eng";
  }

  ngOnInit() {
    this.question.inputList.forEach((input, ind) => {
      if (input.type) {
        const inpCtl = this.questionForm.get("inputList") as UntypedFormArray;
        const ctl = inpCtl.controls[ind] as UntypedFormControl;
        const formCtlAndObj = this.inputValService.getInputFormCtlAndObjMap(
          ctl,
          input
        );
        this.inputValService.inputFormCtlAndObj[
          input.inputControlID
        ] = formCtlAndObj;
      }
    });
    this.onChanges();
  }

  onChanges() {
    this.questionForm.valueChanges.subscribe((val) => { //nosonar
      const allEmpty = arr => arr.every(e => e === '');
      if (this.questionForm.valid && (!allEmpty(this.questionForm.value.inputList))) {
        let inputListAsString;
        if(this.activity["hasDuplicateCheck"]) {
          const indexes = this.activity["hasDuplicateIndex"];
          const inpf = this.questionForm.value.inputList.filter((ipl, index) => {
            return (indexes === index || indexes.some(ind => ind === index))
          })
          inputListAsString = inpf.toString();
        } else {
          inputListAsString = this.questionForm.value.inputList.toString();
        }
        this.activity["questionEntryJson"][this.index] = inputListAsString;
        if (this.activity.questionList.length > 1) {
          
            this.activity.duplicateEntryFlag = this.dupCheckService.checkDuplicateEntry(
              inputListAsString,
              this.index,
              this.activity.questionEntryJson
            );         
          if (this.activity.duplicateEntryFlag) {
            this.activity.errors = {
              flag: true,
              msg: this.translate.instant("DuplicateEntry"),
            };
          } else {
            this.activity.errors = {
              flag: false,
            };
          }
        }
        if (this.question.commonActivity && this.question.commonActivity.flag) {
          const error = this.validateCommonPillarPercentage(
            this.question.inputList,
            this.question.commonActivity.commonPillars
          );
          this.question.errors = error;
          this.activity.errors = error;
        }
      }

      if (this.questionForm.status === Constants.valid) {
        this.report.gsfValid = true;
      } else if (
        this.questionForm.status === Constants.invalid &&
        !this.questionForm.valid
      ) {
        this.report.gsfValid = false;
        this.questionFormValid.emit(
          this.translate.instant("PillarRestrictErrors")
        );
      }
    });
  }
  private getInputValue(inputList, inputId): number {
    let value = 0;
    inputList.forEach((inp) => {
      if (inp.inputControlID === inputId) {
        value = inp.ans;
      }
    });
    return value;
  }

  private validateCommonPillarPercentage(
    inputList,
    commonPillars
  ): QuestionError {
    const errors = {
      flag: false,
      msg: "",
    };
    const firstPillar = this.getInputValue(inputList, commonPillars[0].inputId);
    const secondPillar = this.getInputValue(
      inputList,
      commonPillars[1].inputId
    );

    if (firstPillar && secondPillar) {
      const value =
        parseFloat(firstPillar.toString()) +
        parseFloat(secondPillar.toString());
      if (value !== 100) {
        errors.flag = true;
        errors.msg = this.translate.instant("Percentage100Error");
        return errors;
      } else {
        return errors;
      }
    } else {
      return null;
    }
  }

  setQuestionStatus(status): void {
    if (this.question.status === Constants.noChange) {
      this.question.status = Constants.update;
    }
  }
}
